import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pricingRuleForm.adjustmentsFormSection.title',
    defaultMessage: 'Adjustments',
    description: 'Title of the adjustments form section of the pricing rule form',
  },
};

export default defineMessages(translations);
